var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      { staticClass: "ibox-content", staticStyle: { border: "none" } },
      _vm._l(_vm.topicos, function(topico, indexTopico) {
        return _c("topico_item_big", {
          key: _vm.refreshIndex + topico.id,
          attrs: {
            options: topico,
            index_topico: indexTopico,
            key_id: indexTopico
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }